/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_UpdatedInputs */

const en_admin_roles_updated = /** @type {(inputs: Admin_Roles_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role updated`)
};

/**
* | output |
* | --- |
* | "Role updated" |
*
* @param {Admin_Roles_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_updated = /** @type {((inputs?: Admin_Roles_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_updated(inputs)
});
export { admin_roles_updated as "admin.roles.updated" }